import { Products } from "./components/Products";
import { Testimonials } from "./components/Testimonials";
import { Home } from "./components/Home";
import { Categories } from "./components/Categories";
import { Subcategories } from "./components/Subcategories";
import { Orders } from "./components/Orders";
import { faHouse, faCalendar, faHouseUser, faUsers, faCog } from '@fortawesome/free-solid-svg-icons';

const AppRoutes = [
    {
        index: true,
        path: "/",
        element: <Products />,
        icon: "product-management",
        name: "Products"
    },
    {
        path: "/categories",
        element: <Categories />,
        icon: "category",
        name: "Categories"
    },
    {
        path: "/subcategories",
        element: <Subcategories />,
        icon: "subcategory",
        name: "Subcategories"
    },
    {
        path: "/orders",
        element: <Orders />,
        icon: "order",
        name: "Orders"
    }
];

export default AppRoutes;
